import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import App from "./App";
import "./index.css";

// Runtime config injected by the deploy job (window.__RUNTIME_CONFIG__).
// Falls back to import.meta.env so local dev works via a .env file.
const RC = (
  (globalThis as unknown as { __RUNTIME_CONFIG__?: Record<string, string> })
    .__RUNTIME_CONFIG__ ?? {}
);

posthog.init(RC.POSTHOG_API_KEY ?? import.meta.env.VITE_POSTHOG_API_KEY ?? "", {
  api_host: RC.POSTHOG_HOST ?? import.meta.env.VITE_POSTHOG_HOST ?? "https://ph1.moneygram.com",
  ui_host: "https://us.posthog.com",
  capture_pageview: true,
  session_recording: { maskAllInputs: true },
  loaded: (ph) => {
    if (import.meta.env.DEV) ph.debug();
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
